import React, { useEffect, useRef, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import iconDeleteRed from '../../../../assets/images/icon_delete_red.svg';

const ItemTypes = {
  CARD: 'card',
};

export const Card = ({
  id,
  index,
  menuHighlight,
  user,
  menuItem,
  activeCreateMenuConnection,
  updateMenuItem,
  removeMenuItem,
  connectors,
  setIsDragging,
  generalIsDragging,
  moveCard,
  isCreating,
  draggingCard,
  setDraggingCard,
  handleMenuOptionHighLight,
  currentPath,
}) => {
  const ref = useRef(null);

  const [isCliked, setIsClicked] = useState(false);
  const [wasDragged, setWasDragged] = useState(false);
  const [highlight, setHighLigth] = useState('');

  const handleCheckDisable = () => {
    return (
      isCreating ||
      connectors.some((connector) => connector.from === id) ||
      user?.selectedCompany?.claim?.name === 'Viewer'
    );
  };

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      setDraggingCard(id);
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    setIsDragging(isDragging);
    if (isDragging) {
      setWasDragged(isDragging);
    }
  }, [isDragging]);

  drag(drop(ref));

  const handleOnMouseDown = () => {
    setWasDragged(false);
  };

  const handleOnMouseUp = () => {
    if (!wasDragged) {
      setIsClicked(true);
      handleMenuOptionHighLight(id);
    }

    setWasDragged(false);
  };

  const handleOnblur = () => {
    setIsClicked(false);
    handleMenuOptionHighLight('');
  };

  const isHighLigth = () => {
    let finalStyle = '';
    if (
      menuHighlight.some((menuItemH) => id === menuItemH.from) ||
      currentPath?.from === id
    ) {
      finalStyle = 'block-menu-item-highlight';
    }

    setHighLigth(finalStyle);
  };

  useEffect(() => {
    isHighLigth();
  }, [menuHighlight, currentPath]);

  const opacity = draggingCard === id ? 0.5 : 1;
  const cursor = generalIsDragging ? 'grabbing' : 'grab';
  const cardDraging = isDragging
    ? 'container-remove-button-item draggable-cursor'
    : 'container-remove-button-item';

  return (
    <div
      className={cardDraging}
      ref={ref}
      style={{ opacity, cursor }}
      data-handler-id={handlerId}
    >
      <button
        type="button"
        disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
        className="block-menu-item-minus"
        onClick={(e) => removeMenuItem(e, menuItem)}
      >
        <img src={iconDeleteRed} alt="remover opção" />
      </button>
      <div className={`block-menu-item block-p-menu ${highlight}`}>
        <input
          disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
          id={id}
          value={menuItem.description}
          placeholder="Descrição..."
          onChange={(event) => updateMenuItem(event, menuItem)}
          style={isCliked ? {} : { cursor }}
          onMouseUp={handleOnMouseUp}
          onMouseDown={handleOnMouseDown}
          onBlur={handleOnblur}
        />
        <button
          type="button"
          className="block-menu-item-dot"
          disabled={handleCheckDisable()}
          onClick={(e) => activeCreateMenuConnection(e, menuItem)}
        >
          <i />
        </button>
      </div>
    </div>
  );
};
